import { createApi } from "@reduxjs/toolkit/query/react";
import { getLoggerBaseQuery, expApiBaseQuery } from "../common.js";
import { LIST_TAG } from "../utils.js";
import { TAGS } from "./common.js";
const authoringApi = createApi({
  reducerPath: "exp_authoring_rtkquery",
  baseQuery: getLoggerBaseQuery(expApiBaseQuery),
  endpoints: () => ({}),
  tagTypes: [LIST_TAG, ...Object.values(TAGS)]
});
export {
  authoringApi
};
//# sourceMappingURL=api.js.map
